import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '../ui/tabs';

const ViewSelector = ({ selectedView, setSelectedView }) => {
  const views = ['Sida Vänster', 'Sida Höger', 'Fram', 'Bak', 'Topp'];

  return (
    <Tabs value={selectedView} onValueChange={setSelectedView} className="mb-4 tabs-car-views">
      <TabsList className="w-auto">
        {views.map((view) => (
          <TabsTrigger key={view} value={view}>
            {view}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};

export default ViewSelector;
